import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const CustomModelsPage = loadAsyncComponent(() => import('./Container'), 'page');
